<template>
  <div class="centerPage">
    <div class="centerPage_bigTitle">
      <img src="~images/logo.svg" alt="" />
      Sign Up to EZ Retro
    </div>
    <div class="whiteBox whiteBox_verify">
      <!-- <img class="logo" src="~images/verify.jpg" alt="" /> -->
      Please check your email for a verification link. If you don't receive it please <button type="button" @click="verifyNow"
              :disabled="verify.loading || !!verify.messageSent"
              class="button" >
      <!-- v-bind:class="[verify.loading ? 'loading' : '', 'button', 'loading-center']" -->
      resend
      </button>.
      <div v-if="verify.errorMsg !== ''" class="error-msg">
        {{ verify.errorMsg }}
      </div>
      <div v-if="verify.messageSent !== ''" class="success-msg">
        {{ verify.messageSent }}
      </div>
    </div>
  </div>
  <!--  <div class="verifyEmailPage">-->
  <!--    <div class="verifyEmailPageBox">-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>
  import { ANALYTICS, AUTH } from 'src/firebase-config';
import { mapState } from 'vuex';

export default {
  components: {},
  data() {
    return {
      verify: {
        loading: false,
        messageSent: '',
        errorMsg: ''
      }
    };
  },
  computed: {
    ...mapState(['currentUser']),
    userVerified: function () {
      return this.currentUser && this.currentUser.emailVerified;
    }
  },
  methods: {
    verifyNow() {
      this.verify.loading = true;
      this.verify.messageSent = '';

      AUTH.currentUser
        .sendEmailVerification()
        .then(() => {
          this.verify.loading = false;
          this.verify.messageSent = 'Email sent';
        })
        .catch((err) => {
          this.verify.loading = false;
          this.verify.errorMsg = err.message;
          console.log(err);
        });
    }
  },
  mounted() {
    if (this.userVerified) {
      return this.$router.push('/dashboard');
    }
    ANALYTICS.logEvent('page_view');
  }
};
</script>
